import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary-foreground/20 flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-lg">C</span>
              </div>
              <div>
                <span className="font-bold text-lg">Coblynau</span>
                <span className="text-primary-foreground/80 text-sm ml-1">IT Solutions</span>
              </div>
            </div>
            <p className="text-primary-foreground/80 text-sm mb-4">
              Your trusted IT partner in Swansea, helping businesses thrive with reliable technology solutions.
            </p>
            <div className="flex flex-col gap-2 text-sm text-primary-foreground/80">
              <a
                href="tel:+441234567890"
                className="flex items-center gap-2 hover:text-primary-foreground transition-colors"
              >
                <Phone className="h-4 w-4" />
                01792 567 890
              </a>
              <a
                href="mailto:info@coblynausolutions.co.uk"
                className="flex items-center gap-2 hover:text-primary-foreground transition-colors"
              >
                <Mail className="h-4 w-4" />
                info@coblynausolutions.co.uk
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 flex-shrink-0" />
                Swansea, Wales
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  Microsoft 365
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  IT Support
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  Cloud Services
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  Cyber Security
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  Backup Solutions
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  Website Design
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>
                <Link to="/" className="hover:text-primary-foreground transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary-foreground transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-primary-foreground transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>
                <Link to="/privacy-policy" className="hover:text-primary-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="hover:text-primary-foreground transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-primary-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center text-sm text-primary-foreground/70">
          <p>&copy; {currentYear} Coblynau IT Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
